import HikSetTravelTimeModal from './hik-set-travel-time-modal.vue'
export default HikSetTravelTimeModal
